import { Injectable, Inject } from '@angular/core';
import { LoginInfo } from '../login-interface';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  http: HttpClient;
  baseURL = '';
  data: Object;
  constructor(@Inject(HttpClient) http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseURL = baseUrl;
    this.http = http;
  }

  loginInfo: string[] = [];

  authenticate(email: string, password: string){
    let params = new HttpParams();
    params = params.append('Email', email);
    params = params.append('Password', password);

    console.log("Authenticating" + email + " : " + password);

    return this.http.get(this.baseURL + 'api/Login/AuthenticateLogin', { params: params });
   
  
  }
}

